import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Ab 1024 px feste Seitenleiste, darunter Sheet (iPad hochkant bekommt das Sheet). */
export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");
